import ActionManager from "./base";
import episodeAPI from "../api/episodes";
import {
  episodeDeleteStart,
  episodeDeleteSuccess,
  episodeDeleteError,
} from "../actions/episode_delete_modal";

class EpisodeDeleteActionManager extends ActionManager {
  defaultErrorMessage() {
    return "Uh oh, something went wrong deleting this episode. Please try again later.";
  }

  preCall(dispatch) {
    dispatch(episodeDeleteStart(this.args.episode));
  }

  responseOK(dispatch, json) {
    dispatch(episodeDeleteSuccess(this.args.episode));
    this.showSuccess(dispatch, "Episode Deleted.");
  }
  responseError(dispatch, statusCode, json) {
    dispatch(episodeDeleteError(this.args.episode));
    this.showError(dispatch, this.defaultErrorMessage());
  }

  execute() {
    return episodeAPI.deleteEpisode(this.args.episode, this.args.authToken);
  }

  response400(dispatch, json) {
    this.responseError(dispatch, 400, json);
  }

  catchError(dispatch, err) {
    dispatch(episodeDeleteError(this.args.episode));
    this.showError(dispatch, this.defaultErrorMessage());
  }
}

export default EpisodeDeleteActionManager;
